import { axiosInstance } from '@/api/Base/axiosInstance'

export default class BaseApi {
  #token: string

  #license: string

  #signal: AbortSignal | undefined

  agent: typeof axiosInstance

  constructor(signal?: AbortSignal) {
    this.#token = ''
    this.#license = ''
    this.agent = axiosInstance
    this.#signal = signal
  }

  setToken(token: string) {
    this.#token = token
  }

  getToken() {
    return this.#token
  }

  setLicense(license: string) {
    this.#license = license
  }

  getLicense() {
    return this.#license
  }

  setSignal(signal: AbortSignal) {
    this.#signal = signal
  }

  get signal() {
    return this.#signal
  }
}
